import { createApp, h } from "vue"
import { createInertiaApp } from "@inertiajs/vue3"
import type { DefineComponent } from "vue"

export function bootInertia() {
  return createInertiaApp({
    resolve: (name) => {
      const pages = import.meta.glob<{ default: DefineComponent }>("../pages/**/*.vue", { eager: true })
      const page = pages[`../pages/${name}.vue`]?.default
      if (!page) throw new Error(`Page not found: ${name}`)
      return page
    },
    setup({ el, App, props, plugin }) {
      createApp({ render: () => h(App, props) })
        .use(plugin)
        .mount(el)
    },
  })
}
